<template>
  <b-list-group class="demo-nav-opts" :flush="flush">
    <b-list-group-item class="border-0 rounded-0 px-4 py-1" variant="info">
      <strong>Demo</strong>
    </b-list-group-item>

    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1" variant="info"
      :href="`https://referrals.${domain}`" :disabled="prefix === 'referrals'">Referrals Demo</b-list-group-item>
    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1" variant="info"
      :href="`https://share.${domain}`" :disabled="prefix === 'share'">Share-only Demo</b-list-group-item>
    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1" variant="info"
      :href="`https://im.${domain}`" :disabled="prefix === 'im'">Internal Mobility Demo</b-list-group-item>
    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1" variant="info"
      :href="`https://combined.${domain}`" :disabled="prefix === 'combined'">Combined Demo</b-list-group-item>
    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1" variant="info"
      :href="`https://${domain}`" :disabled="!prefix">Product Demo</b-list-group-item>

    <b-list-group-item class="border-0 rounded-0 px-4 py-1" variant="info"><strong>——</strong></b-list-group-item>

    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1"
      :to="{ name: 'Register' }" variant="info">Register</b-list-group-item>
    <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1" v-if="prefix === 'referrals'"
      :to="{ name: 'EventPage', params: { eventID: 'ca96de424fd224' } }" variant="info">Referral Jam</b-list-group-item>

    <template v-if="prefix">
      <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1"
        :href="`https://${prefix}.${domain}`" :disabled="!`${variation}`.endsWith('-recruiter') && !`${variation}`.endsWith('-employee')"
        variant="info">View as Admin</b-list-group-item>
      <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1"
        :href="`https://${prefix}-recruiter.${domain}`" :disabled="`${variation}`.endsWith('-recruiter')"
        variant="info">View as Recruiter</b-list-group-item>
      <b-list-group-item class="border-0 rounded-0 dropdown-item px-4 py-1"
        :href="`https://${prefix}-employee.${domain}`" :disabled="`${variation}`.endsWith('-employee')"
        variant="info">View as Employee</b-list-group-item>
    </template>
  </b-list-group>
</template>

<script>
export default {
  props: {
    flush: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    prefix() {
      const { variation } = this;
      return variation ? `${variation}`.split('-').shift() : null;
    },
    variation() {
      const { hostname } = this.$root;
      return `${hostname}`.substr(0, `${hostname}`.indexOf('.demo.reallinks.')) || null;
    },
    domain() {
      const { hostname } = this.$root;
      return `${hostname}`.substr(`${hostname}`.indexOf('demo.reallinks.')) || null;
    },
  }
};
</script>

<style lang="scss">
.demo-nav-opts {
  strong {
    color: inherit;
    font-weight: 700;
  }

  .list-group-item.disabled, .dropdown-item.disabled {
    background-color: #BEE5FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DemoNavOpts.vue